function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1v16H0V0zm1 15h15v1H1v-1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.39 9.041l-4.349-5.436L7 6.646 3.354 3l-.708.707L7 8.061l2.959-2.959 3.65 4.564.781-.625z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 9.854a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-1 0v3.5h-3.5a.5.5 0 00-.5.5z",
  clipRule: "evenodd"
});

function SvgChart(props) {
  return React.createElement("svg", _extends({
    className: "chart_svg__bi chart_svg__bi-graph-down",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktZ3JhcGgtZG93biIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDBoMXYxNkgwVjB6bTEgMTVoMTV2MUgxdi0xeiIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjM5IDkuMDQxbC00LjM0OS01LjQzNkw3IDYuNjQ2IDMuMzU0IDNsLS43MDguNzA3TDcgOC4wNjFsMi45NTktMi45NTkgMy42NSA0LjU2NC43ODEtLjYyNXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDkuODU0YS41LjUgMCAwMC41LjVoNGEuNS41IDAgMDAuNS0uNXYtNGEuNS41IDAgMDAtMSAwdjMuNWgtMy41YS41LjUgMCAwMC0uNS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPg==";
export { SvgChart as ReactComponent };